require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-field-services.json") })
        }
      }, "path---services-field-services");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-field-services!./.cache/json/services-field-services.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---services-field-services!./.cache/json/services-field-services.json
// module chunks = 231608221292675